

















































import api from '@/lib/api'
import Vue from 'vue'
export default Vue.extend({
    data(){
        return {
            selected_index: -1,
            categories: [] as { name: string, id: number }[],
            loaded_category: undefined as { name: string, id: number, tickets: string[] } | undefined,
            input: '',
            message: '',
            tickets: [] as ('white' | 'bronze' | 'silver' | 'gold' | 'platinum')[]
        }
    },
    computed: {
        filtered_categories(){

            if(this.input.trim() === "") return (this as any).categories;
            return (this as any).categories.filter((item: { name: string, id: number }) => item.name.includes(this.input));

        }
    },
    watch: {
        async selected_index(curr){
            
            this.loaded_category = undefined; this.tickets = []; this.message = ''
            if(curr === -1) return;

            const response = await api.media.categories.getCategory(this.categories[curr].id);
            if(response.err) return alert("di' a cippi che è successo un casino");
            this.loaded_category = response.ok!.value;
            this.loaded_category.tickets.forEach((ticket) => this.tickets.push(ticket as "white" | "bronze" | "silver" | "gold" | "platinum"))

        }  
    },
    async beforeMount(){

        const response = await api.media.categories.getAllCategoryNames();
        if(response.err) return alert("di' a cippi che è successo un casino")

        this.categories = response.ok!.value;

    },
    methods: {
        async deleteCategory(){
            if(!confirm(`confermi di voler eliminare la categoria "${this.loaded_category?.name}"? tutti i post collegati a questa categoria verranno cancellati!`)) return;

            const response = await api.media.categories.deleteCategory(this.loaded_category!.id);
            if(response.err) return alert("di' a cippi che è successo un casino");

            this.loaded_category = undefined;
            this.categories = (await api.media.categories.getAllCategoryNames()).ok!.value;

        },
        async editCategory(){

            if(!this.loaded_category) return;

            const response = await api.media.categories.editCategory(this.loaded_category.id, this.loaded_category.name, this.tickets);
            if(response.err) return alert("di' a cippi che è successo un casino");

            const reload = await api.media.categories.getAllCategoryNames();
            if(reload.err) return alert("di' a cippi che è successo un casino")

            this.categories = reload.ok!.value;
            this.message = "categoria modificata con successo"

        },
        toggleChoose(item: 'white' | 'bronze' | 'silver' | 'gold' | 'platinum'){
      
            if(this.tickets.includes(item)){
                const index = this.tickets.findIndex(i => i === item);
                this.tickets.splice(index, 1);
            }else{
                this.tickets.push(item);
            }

        }
    }
})
